exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-image {\n  position: relative;\n  top: -2px;\n}\n.vue-base64-file-upload {\n  border: 1px dashed #999;\n  border-radius: 2px;\n  margin-top: 5px;\n  padding-top: 5px;\n  text-align: center;\n}\n.vue-base64-file-upload input {\n  padding: 0 15px 5px 15px;\n  cursor: pointer;\n}", ""]);

// exports
